import {jsPDF} from 'jspdf';
import './Assistant-Bold-bold.js';
import './Assistant-Regular-normal.js';

const TEXT_PADDING = 3;
const TITLE_PADDING = 15;
const BLOCK_PADDING = 5;

const getColumnHeight = (column) => {
  if (column.length === 0)
    return 0;

  const blocksHights = column.reduce((acc, block) => acc + block.height, 0);
  return blocksHights  + (column.length - 1) * BLOCK_PADDING
}

const calculateNumberOfBlocksInPage = (currentPage) => {
  return currentPage.columns.reduce((acc, column) => acc + column.length, 0);
}

const fixWhiteSpaceInCurrentPage = (currentPage, pageHeight, pageWidth) => {
  if (currentPage == null)
    return;

  currentPage.columns.forEach(column => fixWhiteSpaceInCurrentColumn(column, pageHeight));

  if (currentPage.columns.length === 1) {
   currentPage.columns[0].forEach(block => {

     if (block.width !== pageWidth){
         block.width = pageWidth;
         block.textWidth = pageWidth;
     }
   })
  }
}

const addANewPage = (pages, pageHeight, pageWeight) => {
  fixWhiteSpaceInCurrentPage(pages[pages.length - 1], pageHeight, pageWeight)

  pages.push({
    columns: []
  });

  pages[pages.length - 1].columns.push([]);
}

const addBlockToCurrentColumn = (currentColumn, block, blockHeight, blockWidth, textWidth) => {
  currentColumn.push({
    data: block,
    height: blockHeight,
    width: blockWidth,
    textWidth: textWidth,
  })
}

const fixWhiteSpaceInCurrentColumn = (currentColumn, pageHeight) => {
  const currentColumnHeight = getColumnHeight(currentColumn)
  const numberOfSpeerSpace = pageHeight - currentColumnHeight;
  const spaceToAdd = numberOfSpeerSpace / currentColumn.length;

  currentColumn.forEach(block => {
    block.height += spaceToAdd;
  })
}

const addANewColumn = (currentPage) => {
  currentPage.columns.push([]);
}

const handleBlockInFullPageSize = (block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, curBlocksInPage, currentPage, currentColumn, textWidth) => {
  if (curBlocksInPage !== 0) {
    addANewPage(pages, pageHeight, pageWidth);
    return addBlockToPageRecursive(block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, textWidth);
  } else {
    addBlockToCurrentColumn(currentColumn, block, blockHeight, blockWidth, textWidth);
    addANewPage(pages, pageHeight, pageWidth);
  }
}

const handleBlockInColumnSize = (block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, curBlocksInPage, currentPage, currentColumn, textWidth) => {
  if (blockHeight + getColumnHeight(currentColumn) < pageHeight) {
    addBlockToCurrentColumn(currentColumn, block, blockHeight, blockWidth, textWidth);
  } else {
    fixWhiteSpaceInCurrentColumn(currentColumn, pageHeight);

    if (currentPage.columns.length === 2) { // is last column
      addANewPage(pages, pageHeight, pageWidth)
      return addBlockToPageRecursive(block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, textWidth);
    } else {
      addANewColumn(currentPage);
      return addBlockToPageRecursive(block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, textWidth);
    }
  }
}

const addBlockToPageRecursive = (block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, textWidth) => {
  const currentPage = pages[pages.length - 1];
  const currentColumn = currentPage.columns[currentPage.columns.length - 1];

  const curBlocksInPage = calculateNumberOfBlocksInPage(currentPage);

  if (curBlocksInPage === maxBlocksInPage) {
    addANewPage(pages, pageHeight, pageWidth);
    return addBlockToPageRecursive(block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, textWidth);
  }

  if (isFullPage) {
    handleBlockInFullPageSize(block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, curBlocksInPage, currentPage, currentColumn, textWidth);

  } else {
    handleBlockInColumnSize(block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, maxBlocksInPage, curBlocksInPage, currentPage, currentColumn, textWidth)
  }
}

const calculateBlockHeightForPortrait = (block, maxTextWidth, textSplited, fontSize) => {
  let doc = new jsPDF("portrait", 'mm', 'a4');
  doc.setFontSize(14);
  // calculate title height
  doc.setFont("Assistant-Regular", "normal");
  const {w, h} = doc.getTextDimensions(`${block.title}`, {maxWidth: maxTextWidth});

  let firstColumnHeight = h + TITLE_PADDING;
  let secondColumnHeight = 0;

  doc.setFontSize(fontSize);
  block.lines.forEach((exercise, i) => {
    doc.setFont("Assistant-Bold", "bold")

    const exerciseText = `${exercise.name}`;
    const exDimensions = doc.getTextDimensions(exerciseText, { maxWidth: maxTextWidth });

    doc.setFont("Assistant-Regular", "normal")

    const newSunText = exercise.descriptions.map((desc) => reverseHebrewWords(desc));
    const subTextDimensions = doc.getTextDimensions(newSunText, { maxWidth: maxTextWidth});

    let height = exDimensions.h + subTextDimensions.h + TEXT_PADDING;

    if (exDimensions.h !== 0){
      height += TEXT_PADDING;
    }

    if (textSplited) {
      if (i % 2 === 0) {
        firstColumnHeight += height;
      } else {
        secondColumnHeight += height;
      }
    } else {
      firstColumnHeight += height;
    }
  });

  return Math.max(firstColumnHeight, secondColumnHeight);
}

const calculateBlockHeightAndWidthForPortrait = (block, blocksPerPage, pageHeight, pageWidth, fontSize) => {
  if (blocksPerPage === 1) {
    let h = calculateBlockHeightForPortrait(block, pageWidth, false, fontSize);
    let textWidth = pageWidth - TEXT_PADDING;

    if (h > pageHeight) {
      h = calculateBlockHeightForPortrait(block, ((pageWidth - BLOCK_PADDING) / 2), true, fontSize)
      textWidth = ((pageWidth - BLOCK_PADDING) / 2);

      if (h > pageHeight) {
        throw new Error('Block is too big to fit in: ' + block.title);
      }
    }

    return {blockHeight: h, blockWidth: pageWidth, textWidth: textWidth};
  } else {
    let w = (pageWidth - BLOCK_PADDING) / 2;
    let textWidth = w - TEXT_PADDING;

    let h = calculateBlockHeightForPortrait(block, textWidth, false, fontSize);

    if (h > pageHeight) {
      h = calculateBlockHeightForPortrait(block, pageWidth, false, fontSize);
      w = pageWidth;

      if (h > pageHeight) {
        h = calculateBlockHeightForPortrait(block, (pageWidth - BLOCK_PADDING) / 2, true, fontSize)
        textWidth = ((pageWidth - BLOCK_PADDING) / 2) - (2 * TEXT_PADDING);

        if (h > pageHeight) {
          throw new Error('Block is too big to fit in: ' + block.title);
        }
      }
    }

    return {blockHeight: h,
      blockWidth: w,
      textWidth: textWidth};
  }
}


const getBlocksLocationPerPageForPortrait = (blocks, blocksPerPage, pageHeight, pageWidth, fontSize) => {
  const pages = [];
  // add the first page
  addANewPage(pages);
  blocks.forEach((block, index) => {
    const {
      blockHeight,
      blockWidth,
      textWidth
    } = calculateBlockHeightAndWidthForPortrait(block, blocksPerPage, pageHeight, pageWidth, fontSize);
    const isFullPage = blockWidth === pageWidth;

    addBlockToPageRecursive(block, blockHeight, blockWidth, pages, pageHeight, pageWidth, isFullPage, blocksPerPage, textWidth);
  });

  if (pages[pages.length - 1].columns[0].length === 0) {
    pages.pop();
  }

  fixWhiteSpaceInCurrentPage(pages[pages.length - 1], pageHeight, pageWidth)
  return pages;
}

function splitAndProcessText(text) {
  debugger;
  // Regular expressions
  const hebrewRegex = /[\u0590-\u05FF]/;
  const splitRegex = /([\u0590-\u05FF\s]+|[a-zA-Z0-9\s#]+)/g;


  // Split text into Hebrew and English segments
  let segments = text.match(splitRegex);

  if (!segments) return text; // Return original if nothing matches

  return segments
      .map(segment => {
        if (hebrewRegex.test(segment)) {
          // Reverse the order of Hebrew words
          return segment.trim().split(/\s+/).reverse().join(" ").split(" ")
              .map((word) => (word.split("").reverse().join("") ))
              .join(" ")
        } else {
          return segment.trim().split(/\s+/).reverse().join(" ").split(" ")
              .map((word) => (word.split("").reverse().join("") ))
              .join(" ")
        }
      })
      .join(" ");
}

function firstAlphabetCharType(text) {
  for (const char of text) {
    if (/[a-zA-Z]/.test(char)) {
      return false;
    }
    if (/[\u0590-\u05FF]/.test(char)) {
      return true;
    }
  }
  return false; // No alphabetic character found
}

const reverseHebrewWords = (text) => {

  if (firstAlphabetCharType(text))
    return splitAndProcessText(text);
  else
    return text;
};



const drawBlock = (doc, block, xOffset, yOffset, fontSize) => {
  const radius = 5; // Border radius for rounded rectangles
  // Draw the block's background (rounded rectangle)
  doc.setFillColor(255, 255, 255); // White background for blocks
  doc.setTextColor("#000000")
  doc.roundedRect(xOffset, yOffset, block.width, block.height , radius, radius, 'F');

  // Set initial column offset and height trackers
  let currentColumnXOffset = xOffset; // Track current X position for text
  let currentColumnHeight = 0; // Track used height in the current column

  // Title Logic
  const renderTitle = () => {
    doc.setFontSize(14);
    doc.setFont("Assistant-Regular", "normal");
    const title = reverseHebrewWords(`${block.data.title}`);
    const titleDimensions = doc.getTextDimensions(title, { maxWidth: block.textWidth});
    doc.text(title, currentColumnXOffset + TEXT_PADDING, yOffset + 10, { maxWidth: block.textWidth});
    return (titleDimensions.h) + TITLE_PADDING; // Return height used by the title
  };

  let textYOffset = yOffset + renderTitle(); // Render title in the first column
  const blockHeight = textYOffset;

  // Remaining height after the title
  const remainingHeight = block.height - textYOffset + yOffset + 5;

  doc.setFontSize(fontSize);
  block.data.lines.forEach((exercise) => {
    doc.setFont("Assistant-Bold", "bold");
    const exerciseText = reverseHebrewWords(`${exercise.name}`);
    const exDimensions = doc.getTextDimensions(exerciseText, { maxWidth: block.textWidth });

    doc.setFont("Assistant-Regular", "normal")

    const subText = exercise.descriptions.map((desc) => reverseHebrewWords(desc));
    const subTextDimensions = doc.getTextDimensions(subText, { maxWidth: block.textWidth});

    let textHeight = exDimensions.h + subTextDimensions.h; // Height for this text line with padding

    if (subTextDimensions.h !== 0){
      textHeight += TEXT_PADDING;
    }

    // Check if adding this text would exceed the current column height
    if (currentColumnHeight + textHeight > remainingHeight) {

      // Move to the next "virtual column"
      currentColumnXOffset += (block.width/2) + 5; // Add spacing for new column
      currentColumnHeight = 0; // Reset current column height
      textYOffset = blockHeight;

      doc.setLineDash([2, 2], 0); // [dot size, space size], phase 0
      doc.line(currentColumnXOffset -5 , blockHeight - 20, currentColumnXOffset -5, blockHeight + block.height - 30);  // x1, y1, x2, y2

      // doc.setFillColor(0, 0, 0); // White background for blocks
      // doc.roundedRect(currentColumnXOffset + 2, blockHeight, 1, block.blockHeight - 10
      //     - 5, radius, radius, 'F');
    }

    // Draw the text in the current column
    doc.setFont("Assistant-Bold", "bold");
    doc.text(exerciseText, currentColumnXOffset + TEXT_PADDING, textYOffset, { maxWidth: block.textWidth})

    doc.setFont("Assistant-Regular", "normal");
    doc.text(subText, currentColumnXOffset + TEXT_PADDING, textYOffset + exDimensions.h, { maxWidth: block.textWidth})

    // Update offsets and column height
    textYOffset += textHeight;
    currentColumnHeight += textHeight;
  });
};


const usePortrait = (blocks, numberOfBlockPerPage, image, dateStr, workoutName, fontSize) => {
  const doc = new jsPDF('portrait', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  debugger;
  const pages = getBlocksLocationPerPageForPortrait(blocks, numberOfBlockPerPage, pageHeight - 35, pageWidth -20, fontSize)

  pages.forEach((page, pageIndex) => {
    if (pageIndex > 0) {
      doc.addPage();
    }

    // Draw background for each page
    doc.setFillColor(29, 29, 29);
    doc.rect(0, 0, pageWidth, pageHeight, 'F'); // 'F' for filled background
    doc.addImage(image, "PNG", 10, 5, 15, 15);
    doc.setFont("Assistant-Regular", "normal")
    doc.setTextColor("#e0e0e0")
    doc.setFontSize(18);
    doc.text(reverseHebrewWords(workoutName), 30, 10);
    doc.setFont("Assistant-Regular", "normal")
    doc.setFontSize(16);
    doc.text(dateStr, 30, 18);

    const columnSpacing = 5; // Space between columns
    const rowSpacing = 5; // Space between rows

    // Iterate columns first for portrait
    let xOffset = 10;

    page.columns.forEach((column) => {
      let yOffset = 25;

      column.forEach((block, index) => {
        drawBlock(doc, block, xOffset, yOffset, fontSize);
        yOffset += block.height + rowSpacing;
      });

      // Increment xOffset for the next column
      xOffset += column[0].width + columnSpacing;
    });

  });

  // Save the PDF
  doc.save('Workout_Plan.pdf');
};

export default usePortrait;
